import { GatewayControleQuinquennal } from "@conformite/gateway";
import {
  displayErrorToast,
  displaySucessToast,
} from "@endya-conformite/ui-kit";
import { ControleQuinquennalApi } from "@src/data/controle-quinquennal/controle-quinquennal.api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

type CreateRemediationParams = {
  idControleQuinquennal: string;
  idAxe: string;
  payload: GatewayControleQuinquennal.ControleQuinquenalRemediationRequestType;
  files: File[];
};

export const useCreateRemediationMutation = (idEntreprise: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      idControleQuinquennal,
      idAxe,
      payload,
      files,
    }: CreateRemediationParams) =>
      ControleQuinquennalApi.createRemediation(
        idControleQuinquennal,
        idAxe,
        payload,
        files
      ),
    onSuccess: (_, variables) => {
      const { idControleQuinquennal, idAxe } = variables;
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.conversationsByAxes(idAxe),
      });
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.detail(idEntreprise),
      });
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.axesWithFiles(
          idControleQuinquennal,
          idAxe
        ),
      });
      // Le passage en remédiation change le statut de l'axe, donc la
      // conformité vérificateur de la liste.
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.lists(),
      });
      displaySucessToast("Rémédiation créée avec succès");
    },
    onError: () => {
      displayErrorToast(
        "Une erreur est survenue lors de la création de la rémédiation"
      );
    },
  });
};
